import dayjs from 'dayjs'
import { connect } from 'react-redux'
import kebabCase from 'lodash/kebabCase'
import { getCurrentStoreNumber } from 'selectors/getCurrentStore'
import { getCurrentStore } from 'selectors'
import { USER_PLAN_DROP_OFF } from 'constant'
import RequestSentBlockNew from './RequestSentBlockNew'

const formatPhoneNumber = phoneNumber =>
  `(${phoneNumber.areaCode}) ${phoneNumber.firstThree}-${phoneNumber.lastFour}`

export const formatAddress = (address) =>
  address ? `${address.address1}, ${address.city}  ${address.state} ${address.zipcode}` : ''

export const formatDate = (date, time) => {
  const formattedDate = dayjs(date, 'MM/DD/YYYY').format('MMMM D, YYYY')
  return `${formattedDate} - ${time}`
}

const formatPromotionsList = promotions => promotions.map(item => ({
  description: item.promotionShortDescription,
  expirationDate: item.promotionExpiryDate
}))

const formatServiceList = serviceList =>
  serviceList.map(item => item.serviceName)

const generateIdList = serviceList =>
  serviceList.map(item => kebabCase(item.serviceName))

export const formatUserPlan = userPlan =>
  userPlan === USER_PLAN_DROP_OFF ? 'Drop off' : 'Wait'

const mapStateToProps = ({
  appointment: {
    appointmentResponse: {
      orderReviewContactDetails: {
        firstName,
        lastName,
        emailId,
        primaryPhone
      },
      orderReviewVehicleDetails: {
        vehicleNickname
      },
      orderReviewAppointmentDetails: {
        storeAddress,
        appontmentDate,
        dropOffTime,
        userPlan
      },
      selectedServiceItems: {
        selectedServiceDetailsList
      }
    },
    activePromotions
  },
  ...state
}) => ({
  boxFields: [
    { name: 'Appointment Time', value: formatDate(appontmentDate, dropOffTime), fieldType: 'time' },
    { name: 'Drop-off / Wait', value: formatUserPlan(userPlan), fieldType: 'userPlan' },
    { name: 'Store Location', value: formatAddress(storeAddress), fieldType: 'store' }
  ],
  rowFields: [
    {
      name: 'Vehicle',
      value: [vehicleNickname],
      idList: ['info'],
      showBullets: false,
      rowType: 'vehicle'
    },
    {
      name: 'Services Requested',
      value: formatServiceList(selectedServiceDetailsList),
      idList: generateIdList(selectedServiceDetailsList),
      showBullets: true,
      rowType: 'service'
    },
    {
      name: 'Potential Savings',
      value: activePromotions.length ? formatPromotionsList(activePromotions) : null,
      idList: ['potential-savings'],
      showBullets: true,
      rowType: 'promotions'
    },
    {
      name: 'Personal',
      value: [`${firstName} ${lastName}`, formatPhoneNumber(primaryPhone), emailId],
      idList: ['name', 'phone', 'email'],
      showBullets: false,
      rowType: 'personal'
    }
  ],
  storeContactDetails: [
    { asset: 'phone', alt: 'PhoneIcon', value: storeAddress.phoneNumber },
    { asset: 'email-blue', alt: 'EmailIcon', value: `store${getCurrentStoreNumber(state)}@bigostores.com` }
  ],
  firstName,
  storeDetailsUrl: getCurrentStore(state)?.storeDetailsUrl
})


export default connect(mapStateToProps)(RequestSentBlockNew)
